import React from 'react';
import { Card, Skeleton, Empty } from 'antd';
import { ShoppingOutlined } from '@ant-design/icons';
import './styles.scss';

const ProductGallery = ({ products, handleClick, loading = false }) => {
  if (loading) {
    return (
      <div className="product-gallery">
        <h2>Nuestros productos</h2>
        <div className="gallery-container">
          <div className="product-container">
            {[...Array(6)].map((_, index) => (
              <div key={index} className="product-card">
                <Card className="card-content">
                  <Skeleton.Image active style={{ width: '100%', height: '200px' }} />
                  <Skeleton active paragraph={{ rows: 2 }} />
                </Card>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (!products || products.length === 0) {
    return (
      <div className="product-gallery">
        <h2>Nuestros productos</h2>
        <div className="gallery-container">
          <Empty 
            description="No hay productos disponibles" 
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="product-gallery">
      <h2>Nuestros productos</h2>
      <div className="gallery-container">
        <div className="product-container">
          {products.map((product) => (
            <div key={product.id} className="product-card">
              <Card
                hoverable
                cover={
                  <div className="product-image-container">
                    <img 
                      alt={product.name} 
                      src={product.images?.[0] || "https://placehold.co/300x200?text=Sin+imagen"} 
                      onError={(e) => {
                        e.target.src = "https://placehold.co/300x200?text=Error+imagen";
                      }}
                    />
                  </div>
                }
                className="card-content"
                onClick={() => handleClick(product)}
              >
                <Card.Meta 
                  title={product.name} 
                  description={
                    <div className="product-description">
                      {product.description && (
                        <span className="description-text">
                          {product.description.length > 80 
                            ? `${product.description.substring(0, 80)}...` 
                            : product.description
                          }
                        </span>
                      )}
                    </div>
                  }
                />
                <div className="card-footer">
                  <p className="product-price">
                    ${product.price ? product.price.toLocaleString() : '0'}
                  </p>
                  {product.stock !== undefined && (
                    <span className={`stock-badge ${product.stock === 0 ? 'out-of-stock' : 'in-stock'}`}>
                      {product.stock === 0 ? 'Agotado' : `Stock: ${product.stock}`}
                    </span>
                  )}
                </div>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductGallery;